import {
  CalendarModule, DataTableModule, DialogModule, OrderListModule, SpinnerModule,
  MultiSelectModule, TabViewModule
} from 'primeng/primeng';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BackTopComponent } from './back-top/back-top.component';
import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { CommonModule } from '@angular/common';
import { DialogService } from './services/dialog.service';
import { DropdownEditableComponent } from './dropdown-editable/dropdown-editable.component';
import { FilterItemComponent } from './filter-item/filter-item.component';
import { FilterTextModule } from './filter-text/filter-text.module';
import { HttpModule } from '@angular/http';
import { InputEditableComponent } from './input-editable/input-editable.component';
import { LocalizedCalendarComponent } from './localized-calendar/localized-calendar.component';
import { LocalizedDatePipe } from './services/localized-date.pipe';
import { NavSecondComponent } from './nav-second/nav-second.component';
import { NgModule } from '@angular/core';
import { NumericInputEditableComponent } from './numeric-input-editable/numeric-input-editable.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    SpinnerModule,
    FilterTextModule,
    CalendarModule,
    BreadcrumbModule,
    DataTableModule,
    DialogModule,
    OrderListModule,
    MultiSelectModule
  ],
  exports: [
    CommonModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TabViewModule,

    FilterTextModule,
    BackTopComponent,
    FilterItemComponent,
    LocalizedCalendarComponent,
    NavSecondComponent,
    InputEditableComponent,
    NumericInputEditableComponent,
    DropdownEditableComponent,
    LocalizedDatePipe
  ],
  declarations: [
    BackTopComponent,
    FilterItemComponent,
    LocalizedCalendarComponent,
    NavSecondComponent,
    InputEditableComponent,
    NumericInputEditableComponent,
    DropdownEditableComponent,
    LocalizedDatePipe
  ],
  providers: [
    DialogService
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/shared.module.ts